import IconAndInformation from "components/common/IconAndInformation";
import { v4 as uuidv4 } from "uuid";
import s from "./styles";

function TopWidgetInformation({ elements = [] }) {
  return (
    <s.Container>
      <s.InformationContainer>
        {elements.map((e) => (
          <IconAndInformation
            key={uuidv4()}
            icon={e.icon}
            top={e.value}
            bottom={e.text}
          />
        ))}
      </s.InformationContainer>
    </s.Container>
  );
}

export default TopWidgetInformation;
